export default "__VITE_ASSET__B_1gnBgh__"